import type {ConsentState} from "./consentStore";

/**
 * When the always-available consent-withdrawal control is shown (kitecorp/transferify-ui#2675).
 * React-free by mandate (epic #26), so the rule can be asserted directly rather than through a
 * rendered shell.
 *
 * <p><b>Why the control exists.</b> Withdrawing consent has to be as easy as giving it (GDPR
 * Art. 7(3)), and the German DSK's Orientierungshilfe (Nov 2024) is specific about what fails that
 * test: a control the visitor can only reach by opening the privacy policy and scrolling to find it
 * is itself an obstacle, and a link to a provider's own opt-out page is not a withdrawal control at
 * all. Consent is given in one press on a bar that is on every page, so withdrawal is one press on
 * a control that is on every page. Until this ticket the only way back was the top bar's Resources
 * dropdown, which is two.
 *
 * <p><b>Why it is hidden before a decision.</b> The banner IS the control then, and it already
 * carries Reject and Customize. Two controls asking the same question at once would leave the
 * visitor to work out which one answers it, and the second would sit under a bar the page has
 * already reserved room for.
 *
 * <p><b>Every route, no exceptions.</b> There is deliberately no route rule here, unlike
 * `nav/siteFooterRoutes`. The delivery surfaces that carry no footer DO run the advertising tag and
 * DO show the consent bar, so they are exactly the pages where a visitor may want to take the
 * permission back. A route exemption here would be an exemption from Art. 7(3).
 */
export function showsWithdrawalControl(consent: ConsentState): boolean {
	return consent.decided;
}
